import { render, staticRenderFns } from "./OtherProject.vue?vue&type=template&id=719626ac&"
import script from "./OtherProject.vue?vue&type=script&lang=js&"
export * from "./OtherProject.vue?vue&type=script&lang=js&"
import style0 from "./OtherProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports